<script setup>
import { 
    FormItem as AFormItem, 
    DatePicker as ADatePicker, 
    Select as ASelect, 
    SelectOption as ASelectOption,
    TimePicker as ATimePicker,
    Input as AInput,
    Textarea as ATextarea,
    Radio
} from 'ant-design-vue';
import { useField } from 'vee-validate';
import { onMounted, ref } from 'vue';
import NoDataModal from '../no-data-modal/no-data-modal.vue';

import axios from 'axios';

import { debounce } from '../../helpers';
import { useToast } from 'vue-toastification';

import store from '@/store';
import router from '@/router';

// я знаю, что это ужас. поджимало время, не поминайте лихом
const {value: dateEvent, errorMessage: dateEventErrorMessage} = useField("event_date");
const {value: timeEvent, errorMessage: timeEventErrorMessage} = useField("event_time");
const {value: eventLocationISN, errorMessage: eventLocationISNErrorMessage} = useField("event_location_isn");

const {value: eventAddress, errorMessage: eventAddressMessage} = useField("event_address");

const {value: eventFaultTypeISN, errorMessage: eventFaultTypeISNErrorMessage} = useField("event_fault_type_isn");
const {value: perpetratorIIN, errorMessage: perpetratorIINErrorMessage} = useField("perpetrator_iin");
const {value: perpetratorFullName, errorMessage: perpetratorFullNameErrorMessage} = useField("perpetrator_full_name");

const {value: perpetratorModel, errorMessage: perpetratorModelErrorMessage} = useField("perpetrator_vehicle_mark_model");
const {value: perpetratorPlate, errorMessage: perpetratorPlateErrorMessage} = useField("perpetrator_vehicle_plate_number");

const {value: description, errorMessage: descriptionErrorMessage} = useField("event_description");
const {value: damageAmount, errorMessage: damageAmountErrorMessage} = useField("estimated_damage_amount");

const {value: isRegisteredByAuthorities, errorMessage: isRegisteredByAuthoritiesErrorMessage} = useField("is_registered_by_authorities");
const {value: alcoholTestPassed, errorMessage: alcoholTestPassedErrorMessage} = useField("alcohol_test_passed");
const {value: isSurveyorPresent, errorMessage: isSurveyorPresentErrorMessage} = useField("is_surveyor_present");
const {value: hasVideo, errorMessage: hasVideoErrorMessage} = useField("has_video_recording");
const {value: isTotalLoss, errorMessage: isTotalLossErrorMessage} = useField("is_total_loss");

const visibleNoDataModal = ref(false);
const toaster = useToast();

const handleCheckUser = debounce(async (event) => {
        const value = event.target.value;

        if (value.length === 12) {
            perpetratorFullName.value = "";
            
            const {data} = await axios.get(`/V1/road-accidents/subject-info?iin=${value}`).catch(err => {
                toaster.error(err.response.data.message);
                visibleNoDataModal.value = true;
            });

            
            if (data.data.surname) {
                perpetratorFullName.value += data.data.surname + " ";
            }

            if (data.data.name) {
                perpetratorFullName.value += data.data.name + " ";
            }

            if (data.data.patronymic) {
                perpetratorFullName.value += data.data.patronymic;
            }   
        }
}, 1000);

const handleChangeDate = (value) => {
    const date = value.format("YYYY-MM-DD");
    dateEvent.value = date;
};

const handleChangeTime = (event) => {
    const value = event.target.value.replace(/[а-яА-ЯёЁa-zA-Z]/gi, "");
    timeEvent.value = value;
};

const onlyNumbers = (e) => {
    const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    
    if (allowed.includes(e.key)) return;
    
    if (!/^\d$/.test(e.key)) {
        e.preventDefault();
    }
};

const onPaste = (e) => {
    const text = e.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(text)) {
        e.preventDefault();
    }
};

const handleChangeCrashSum = (event) => {
    if (event.target.value === "") {
        damageAmount.value = "";
        return;
    }

    const value = parseInt(event.target.value.replaceAll(/[^0-9]/g, ""));
    const formatter = Intl.NumberFormat("ru-RU");

    damageAmount.value = formatter.format(value);
};

const handleCloseNoDataModal = () => {
    visibleNoDataModal.value = false;
};

const handleChangeGuilty = () => {
    perpetratorIIN.value = undefined;
    perpetratorFullName.value = undefined;
    perpetratorModel.value = undefined;
    perpetratorPlate.value = undefined;
};

// в ином месте / на парковочном месте / ...
const locationHandbook = ref([]);

// По моей вине / по вине водителя / в результате кражи или угона / ...
const guiltyHandbook = ref([]);

onMounted(() => {
    axios.get(`/V1/road-accidents/catalogs/fault-types`).then(({data}) => {
        guiltyHandbook.value = data.map(({id, name}) => ({id: String(id), name}));
    }).catch(err => {
        if(err.status === 401){
            store.dispatch('auth/logoutTokenUnactive')
            router.push('/')
            return;
        }
        toaster.error(err.response.data.message)
    });

    axios.get(`/V1/road-accidents/catalogs/event-locations`).then(({data}) => {
        locationHandbook.value = data.map(({id, name}) => ({id: String(id), name}));
    }).catch(err => {
        if(err.status === 401){
            store.dispatch('auth/logoutTokenUnactive')
            router.push('/')
            return;
        }
        toaster.error(err.response.data.message)
    });
});

</script>

<template>
    <div class="insured-details">
        <h2 class="insured-details__title">Информация о страховом событии КАСКО</h2>

        <div class="insured-details-inputs">
            <AFormItem
                label="Дата события"
                :validate-status="dateEventErrorMessage"
                :help="dateEventErrorMessage ? dateEventErrorMessage : ''"
            >
                <ADatePicker
                    placeholder="Дата события"
                    class="questionnaire_card_input"
                    :class="dateEventErrorMessage ? 'error' : ''"
                    format="DD.MM.YYYY"
                    @change="handleChangeDate"
                    v-maska="'XX.XX.XXXX'"
                />
            </AFormItem>

            <AFormItem
                label="Время страхового события"
                :validate-status="timeEventErrorMessage"
                :help="timeEventErrorMessage ? timeEventErrorMessage : ''"
            >
                <AInput
                    placeholder="Время страхового события"
                    class="questionnaire_card_input"
                    :class="timeEventErrorMessage ? 'error' : ''"
                    v-maska="'XX:XX'"
                    @change="handleChangeTime"
                    v-model:value="timeEvent"
                />
            </AFormItem>

            <AFormItem
                label="Место наступления страхового события"
                :validate-status="eventLocationISNErrorMessage"
                :help="eventLocationISNErrorMessage ? eventLocationISNErrorMessage : ''"
            >
                <ASelect
                    class="questionnaire_card_input select"
                    :class="eventLocationISNErrorMessage ? 'error' : ''"
                    placeholder="Выберите место"
                    v-model:value="eventLocationISN"
                >
                    <ASelectOption
                        v-for="{id, name} in locationHandbook"
                        :key="id"
                        :value="id"
                    >
                        {{ name }}
                    </ASelectOption>
                </ASelect>
            </AFormItem>

            <AFormItem
                label="Данное страховое событие произошло:"
                :validate-status="eventFaultTypeISNErrorMessage"
                :help="eventFaultTypeISNErrorMessage ? eventFaultTypeISNErrorMessage : ''"
            >
                <ASelect
                    class="questionnaire_card_input select"
                    placeholder="Выберите ответственную сторону"
                    :class="eventFaultTypeISNErrorMessage ? 'error' : ''"
                    v-model:value="eventFaultTypeISN"
                    @change="handleChangeGuilty"
                >
                    <ASelectOption
                        v-for="{id, name} in guiltyHandbook"
                        :key="id"
                        :value="id"
                    >
                        {{ name }}
                    </ASelectOption>
                </ASelect>
            </AFormItem>

            <AFormItem
                label="ИИН виновника"
                :validate-status="perpetratorIINErrorMessage"
                :help="perpetratorIINErrorMessage ? perpetratorIINErrorMessage : ''"
                v-if="eventFaultTypeISN === '6196321'"
            >
                <AInput
                    :placeholder="'Укажите ИИН'"
                    class="questionnaire_card_input"
                    v-model:value="perpetratorIIN"
                    v-maska="'XXXXXXXXXXXX'"
                    @input="handleCheckUser"
                    :class="perpetratorIINErrorMessage ? 'error' : ''"
                />
            </AFormItem>

            <AFormItem
                label="ФИО виновника"
                :validate-status="perpetratorFullNameErrorMessage"
                :help="perpetratorFullNameErrorMessage ? perpetratorFullNameErrorMessage : ''"
                v-if="eventFaultTypeISN === '6196321'"
            >
                <AInput
                    :placeholder="'Укажите ФИО'"
                    class="questionnaire_card_input"
                    v-model:value="perpetratorFullName"
                    :class="perpetratorFullNameErrorMessage ? 'error' : ''"
                />
            </AFormItem>

            <AFormItem
                label="Марка/модель ТС виновника"
                :validate-status="perpetratorModelErrorMessage"
                :help="perpetratorModelErrorMessage ? perpetratorModelErrorMessage : ''"
                v-if="eventFaultTypeISN === '6196321'"
            >
                <AInput
                    :placeholder="'XXXXXXXXX'"
                    class="questionnaire_card_input"
                    v-model:value="perpetratorModel"
                    :class="perpetratorModelErrorMessage ? 'error' : ''"
                />
            </AFormItem>

            <AFormItem
                label="Гос.номер ТС виновника"
                :validate-status="perpetratorPlateErrorMessage"
                :help="perpetratorPlateErrorMessage ? perpetratorPlateErrorMessage : ''"
                v-if="eventFaultTypeISN === '6196321'"
            >
                <AInput
                    :placeholder="'XXXXXXXXX'"
                    class="questionnaire_card_input"
                    v-model:value="perpetratorPlate"
                    v-maska="'XXXXXXXX'"
                    :class="perpetratorPlateErrorMessage ? 'error' : ''"
                />
            </AFormItem>

            <AFormItem
                label="Краткое описание страхового события"
                :validate-status="descriptionErrorMessage"
                :help="descriptionErrorMessage ? descriptionErrorMessage : ''"
                class="textarea-wrapper"
            >
                <ATextarea
                    :placeholder="'Укажите краткое описание'"
                    class="questionnaire_card_input textarea"
                    v-model:value="description"
                    :class="descriptionErrorMessage ? 'error' : ''"
                    resize="none"
                />
            </AFormItem>

            <AFormItem
                label="Примерная сумма ущерба"
                :validate-status="damageAmountErrorMessage"
                :help="damageAmountErrorMessage ? damageAmountErrorMessage : ''"
            >
                <AInput
                    :placeholder="'Укажите сумму'"
                    class="questionnaire_card_input"
                    v-model:value="damageAmount"
                    :class="damageAmountErrorMessage ? 'error' : ''"
                    @change="handleChangeCrashSum"
                    @keydown="onlyNumbers"
                    @paste="onPaste"
                />
            </AFormItem>

            <AFormItem
                label="Адрес события"
                :validate-status="eventAddressMessage"
                :help="eventAddressMessage ? eventAddressMessage : ''"
            >
                <AInput
                    :placeholder="'Укажите адрес события'"
                    class="questionnaire_card_input"
                    :class="eventAddressMessage ? 'error' : ''"
                    v-model:value="eventAddress"
                />
            </AFormItem>
        
            <ul class="questions-list">
                <li>
                    <AFormItem
                        label="Данное страховое событие зарегистрировано гос. компетентными органами? (органами внутренних дел, полиции, пожарной службы и др)"
                        :validate-status="isRegisteredByAuthoritiesErrorMessage"
                        :help="isRegisteredByAuthoritiesErrorMessage ? isRegisteredByAuthoritiesErrorMessage : ''"
                    >
                        <Radio.Group
                            v-model:value="isRegisteredByAuthorities"
                            :class="isRegisteredByAuthoritiesErrorMessage ? 'error' : ''"
                        >
                            <Radio value="true">ДА</Radio>
                            <Radio value="false">НЕТ</Radio>
                        </Radio.Group>
                    </AFormItem>
                </li>

                <li>
                    <AFormItem
                        label="Экспертизу на предмет установления алкогольного (наркотического) опьянения проходил?"
                        :validate-status="alcoholTestPassedErrorMessage"
                        :help="alcoholTestPassedErrorMessage ? alcoholTestPassedErrorMessage : ''"
                    >
                        <Radio.Group
                            v-model:value="alcoholTestPassed"
                            :class="alcoholTestPassedErrorMessage ? 'error' : ''"
                        >
                            <Radio value="true">ДА</Radio>
                            <Radio value="false">НЕТ</Radio>
                        </Radio.Group>
                    </AFormItem>
                </li>

                <li>
                    <AFormItem
                        label="Аварийный комиссар на месте страхового события присутствовал"
                        :validate-status="isSurveyorPresentErrorMessage"
                        :help="isSurveyorPresentErrorMessage ? isSurveyorPresentErrorMessage : ''"
                    >
                        <Radio.Group
                            v-model:value="isSurveyorPresent"
                            :class="isSurveyorPresentErrorMessage ? 'error' : ''"
                        >
                            <Radio value="true">ДА</Radio>
                            <Radio value="false">НЕТ</Radio>
                        </Radio.Group>
                    </AFormItem>
                </li>

                <li>
                    <AFormItem
                        label="Имеется ли видеозапись страхового события, заснятая видеорегистратором?"
                        :validate-status="hasVideoErrorMessage"
                        :help="hasVideoErrorMessage ? hasVideoErrorMessage : ''"
                    >
                        <Radio.Group
                            v-model:value="hasVideo"
                            :class="hasVideoErrorMessage ? 'error' : ''"
                        >
                            <Radio value="true">ДА</Radio>
                            <Radio value="false">НЕТ</Radio>
                        </Radio.Group>
                    </AFormItem>
                </li>

                <li>
                    <AFormItem
                        label="Полная гибель автомобиля"
                        :validate-status="isTotalLossErrorMessage"
                        :help="isTotalLossErrorMessage ? isTotalLossErrorMessage : ''"
                    >
                        <Radio.Group
                            v-model:value="isTotalLoss"
                            :class="isTotalLossErrorMessage ? 'error' : ''"
                        >
                            <Radio value="true">ДА</Radio>
                            <Radio value="false">НЕТ</Radio>
                        </Radio.Group>
                    </AFormItem>
                </li>
            </ul>
        </div>
    </div>

    <NoDataModal
        :visible="visibleNoDataModal"
        @close="handleCloseNoDataModal"
    />
</template>

<style>
.insured-details {
    margin-top: 60px;
}

.insured-details__title {
    font-family: "Roboto", sans-serif;
    font-size: 24px;
    color: #373737;
}

.insured-details-inputs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
}

.select {
    .ant-select-selector {
        background-color: transparent !important;
        border: none !important;
        height: 55px !important;
    }

    .ant-select-selection-placeholder, .ant-select-selection-item {
        display: flex;
        align-items: center;
    }
}

.questions-list {
    margin-left: 15px;
    list-style-type: decimal;
    grid-column: span 2;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    row-gap: 30px
}

.textarea-wrapper {
    grid-column: span 2;
}

.textarea {
    min-height: 200px!important;
}
</style>